// extracted by mini-css-extract-plugin
module.exports = {"layoutContainer":"TicketLanding_layoutContainer__oUriV","qr":"TicketLanding_qr__TnHIE"};